export const PaymentConstants = {
  locationURL: 'https://ipwho.is/?fields=country_code,continent',
  initiatePaymentURL: '/stripe/initiate-payment',
  createSubscriptionURL: '/stripe/create-subscription',
  configURL: '/stripe/config',
  regions: {
    uk: 'uk',
    europe: 'europe',
    common: 'common',
  },
  subscriptionDuration: {
    monthly: 'monthly',
    annually: 'annually',
  },
  subscriptionProduct: {
    studio: 'Studio',
    pro: 'Pro',
    trial: 'Trial',
  },
  subscriptionURLQueries: {
    region: 'region',
    plan: 'plan',
    duration: 'duration',
  },
  countryCodes: {
    gb: 'gb',
  },
  stripePriceKeys: {
    annually: 'stripePriceAnnually',
    monthly: 'stripePriceMonthly',
  },
  priceKeys: {
    annually: 'PriceAnnually',
    monthly: 'PriceMonthly',
  },
  getStripePriceKey: (period) => {
    if (period === 1) return PaymentConstants.stripePriceKeys.annually
    return PaymentConstants.stripePriceKeys.monthly
  },
  getProductPeriodPackage: (period) => {
    if (period === 1) return PaymentConstants.subscriptionDuration.annually
    return PaymentConstants.subscriptionDuration.monthly
  },
}
